module.exports = __webpack_public_path__ + "assets/img/QR-code.6eeb1400.png";